import { retrievePDF } from "../save-to-pdf";

export default (method, sim = {}, update = false, isDeleted = false) => (dispatch, getState) => {

  const { token, clientEmail, entry, analysis, wtRegion }  = getState()
  const portfolioId = analysis ? analysis[0].id : entry.original.id
  if (isDeleted) dispatch({ type: 'DELETE_MONTE_CARLO', id: sim.id, pending: true })

  const makeTheCall = (url, body, callback, onSuccess, localMethod) => {
    fetch(url, {
      method: localMethod || method,
      ...(body ? { body } : {}),
      headers: {
        'Content-Type': 'application/json',
        Authorization: token &&
          `Token ${token}`,
      }
    })
    .then(d => {
      if(d.status === 404){
        return []
      }
      onSuccess && onSuccess()
      return d.json()
    })
    .then(callback)
    .catch(error => {
      console.error(error);
    })
  }

  let body, callback, onSuccess;
  let url = process.env.REACT_APP_API_URL+'/montecarlo/custom/'

  if(method === 'GET' && update === false){ // get all sims
    url += `find_by_email/?clientEmail=${clientEmail}&wtRegion=${wtRegion}&entityCCY=${entry.original.entityCCY}`
    callback = sims => {
      dispatch({ 
        type: 'LOAD_SAVED_MONTE_CARLOS',
        sims: sims.length > 0 ? sims : []
      })
    }

  } else if (method === 'PUT' && update === true){ // existing MC: update MC, then rerun analysis
    dispatch({ type: 'LOADING' })
    url += (sim.id+'/')
    body = JSON.stringify({
      ...sim,
      clientEmail,
      portfolioIds: [ ...(sim.portfolioIds || []), portfolioId ],
    });
    callback = sims => {
      dispatch({ type: 'SET_MONTE_CARLO_SAVED', saveAll: false, id: sim.id })
      makeTheCall(
        process.env.REACT_APP_API_URL+`/portfolio/rerun_monte_carlo/?id=${portfolioId}&monte_carlo_id=${sim.id}`,
        null,
        data => {
          dispatch({ type: 'UPDATE_ANALYSIS_MONTE_CARLO', data });
          setTimeout(() => {
            dispatch(retrievePDF)
          }, 500)
        },
        null,
        'GET'
      )
    }

  } else if (method === 'PUT') { // delete MC, no rerun
    url += (sim.id+'/')
    body = JSON.stringify({
      ...sim,
      clientEmail,
      isDeleted,
      portfolioIds: [ ...(sim.portfolioIds || []), portfolioId ],
    });
    callback = data => {
      if(isDeleted) {
        dispatch({ type: 'DELETE_MONTE_CARLO', id: data.id, pending: false });
      } else {
        dispatch({ type: 'SET_MONTE_CARLO_SAVED', saveAll: false, id: data.id })
      }
    }

  } else if(method === 'POST') { // new MC: save MC(s), then rerun analysis
    dispatch({ type: 'LOADING' })
    let sims = sim.length 
      ? sim.map(d => ({ 
          ...d, 
          clientEmail, 
          wtRegion, 
          entityCCY: entry.original.entityCCY, 
        })) 
      : [{ ...sim, clientEmail, wtRegion, entityCCY: entry.original.entityCCY }]
    body = JSON.stringify(sims);
    callback = sims => {
      dispatch({ type: 'LOAD_SAVED_MONTE_CARLOS', sims })
      dispatch({ type: 'SET_MONTE_CARLO_SAVED', saveAll: true })
      dispatch({ type: 'SELECT_MONTE_CARLO', index: 0 })
      makeTheCall(
        process.env.REACT_APP_API_URL+`/portfolio/rerun_monte_carlo/?id=${portfolioId}&monte_carlo_id=${sims[0].id}`,
        null,
        data => {
          dispatch({ type: 'UPDATE_ANALYSIS_MONTE_CARLO', data });
          setTimeout(() => {
            dispatch(retrievePDF)
          }, 500)
        },
        null,
        'GET'
      )
    };
  }

  makeTheCall(url, body, callback, onSuccess);

};


// WEBPACK FOOTER //
// ./src/actions/query-api/monte-carlo.js